import React from "react";

import SongListItem from "./song-list-item";
import { useAudioPlayer } from "../../context/audio-player-context";

type Props = {
  songs: Songs;
  isLoading: boolean;
};

const SongsList: React.FC<Props> = props => {
  const { setCurrentSong, setSongs } = useAudioPlayer();

  const playSong = (song: Song, index: number) => {
    setCurrentSong(song);
    setSongs(props.songs, index);
  };

  const songs = props.songs || [];

  return (
    <div className="flex flex-col space-y-3">
      {songs.map((song, index) => (
        <SongListItem key={song.id} song={song} play={() => playSong(song, index)} />
      ))}

      {props.isLoading &&
        Array.from(Array(5).keys()).map(id => (
          <div key={id} className="flex bg-gray-200 rounded-md animate-pulse">
            <div className="w-20 h-16 bg-gray-400 sm:w-24 sm:h-20 rounded-l-md" />

            <div className="flex-1 px-3 py-2">
              <p className="h-4 pr-4 bg-gray-400 rounded-lg" />
              <p className="w-3/4 h-2 mt-2 bg-gray-400 rounded-lg" />
            </div>
          </div>
        ))}
    </div>
  );
};

export default SongsList;
